module.exports = __webpack_public_path__ + "industriaitaliana.jpg?59ea85002e38e033a11d0bb5659b16bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriaitaliana.jpg
// module id = 213
// module chunks = 0